import React from 'react';
import { MainMonthBlockForm } from '../../../../components/MainInMonth/MainMonthBlockForm';
import { IDataOpt } from '../../../../components/ui/SelectSearchReq';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../../../store/applicationState';
import { GetConsultations } from '../../../../store/consultations/actions';
import { CATEGORIES } from '../../../../utils/consts';

export default function Form({ type }: { type: 'new' | 'edit' }) {
  const { Configurations, Consultations } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      GetConsultations.request({
        data: {
          siteId: Configurations.siteId,
          is_news: 1,
        },
      })
    );
  }, [dispatch, Configurations.siteId]);

  const handleSearchPublications = (value: string | IDataOpt, callback?: ((data: IDataOpt[]) => void) | undefined) => {
    let id = 0;
    if (typeof value !== 'string') {
      id = value.id;
    } else if (!Number.isNaN(Number(value))) {
      id = Number(value);
    }

    dispatch(
      GetConsultations.request({
        data: {
          siteId: Configurations.siteId,
          id,
          is_news: 1,
        },
        callBack: (success, data) => {
          if (success && data?.consultations && callback) {
            callback(
              data.consultations
                .filter((item: { is_public: any }) => !!item.is_public)
                .map((item: { id: any }) => ({
                  id: item.id,
                  label: String(item.id),
                }))
            );
          }
        },
      })
    );
  };

  return (
    <MainMonthBlockForm
      type={type}
      name={`${type === 'new' ? 'Створити' : 'Редагувати'} блок шаблону Новини`}
      category={CATEGORIES.CONSULTATIONS}
      fields={{
        publication_id: { require: true },
        title: { require: true },
        description: { require: false },
      }}
      handleSearchPublications={handleSearchPublications}
      publications={Consultations.consultations
        ?.filter((item) => !!item.is_public)
        .map((item) => ({
          id: item.id,
          label: String(item.id),
          title: item.title,
        }))}
    />
  );
}
